module.exports = __webpack_public_path__ + "img/TheMembers-5-pt.215bafaa.png";